import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { ContextMenuElement } from '@m4u-angular/base/classes/BaseClasses';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, CreateCredentialsParams, CredentialsCheckerMetadata, CredentialExternalInfo, CredentialType, SystemCredentialInfo }
    from '@m4u-angular/base/entities/BaseEntities';
import { CredentialActivityEndpoint } from '@m4u-angular/core/endpoints/credential-activity.endpoint';

class State extends BaseState {

}

@Component({
    providers: ServiceBagServices,
    selector: 'app-system-credentials-creation-grid',
    templateUrl: './system-credentials-creation-grid.component.html',
    styleUrls: ['./system-credentials-creation-grid.component.scss']
})
export class SystemCredentialsCreationGridComponent extends BaseGridComponent<SystemCredentialInfo, State> {
    @Input() AdditionalInfoMetadata: CredentialsCheckerMetadata;
    @ViewChild('grid') grid: any;
    @Output() OnSelectionChanged = new EventEmitter<CredentialExternalInfo[]>();
    @Input() CredentialTypes: CredentialType[];

    constructor(A: ServiceBagService, private credentialActivityEndpoint: CredentialActivityEndpoint) {
        super(A, 'SystemCredentialsCreationGridComponent', SystemCredentialInfo, State);

    }

    protected override GetGridRowContextMenu(options?: any): ContextMenuElement[] {
        return [{
            text: this.RC('btnCreateCredentials'),
            visible: true,
            onClick: () => this.OnManageCredentials(options)
        }];
    }

    OnGridSelectionChanged(event: any) {
        this.OnSelectionChanged.emit(this.grid.instance?.getSelectedRowsData());
    }

    OnManageCredentials(options: any) {
        const { Type, EntryID } = options.data;
        this.Navigate(['/pages/passwordmanage'], { CredentialID: EntryID, Type: Type });
    }
}
